import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDeposit = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={40} height={41} fill='none' {...props}>
    <rect width={40} height={40} y={0.5} fill='#26C6DA' rx={8} />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d='m17.32 20.18 2.56 2.56 2.56-2.56M19.88 12.5v10.17'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d='M28 20.68c0 4.42-3 8-8 8s-8-3.58-8-8'
    />
  </svg>
);
export default SvgDeposit;
